import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";

function formatNumber(value) {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return "—";
  }

  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default function QuoteData(props) {
  if (!props.instrument || !props.instrument.quoteData) return null;

  const quote = props.instrument.quoteData;
  const meta = props.instrument.metrics?.meta || {};
  const isNegativeChange = Number(quote.d) < 0;
  const percentChange =
    quote.dp === null || quote.dp === undefined
      ? "—"
      : Number(quote.dp).toFixed(2);
  const price = formatNumber(quote.c);
  const change = formatNumber(quote.d);
  const dayLow = formatNumber(quote.l);
  const dayHigh = formatNumber(quote.h);
  const fiftyTwoWeekLow = formatNumber(
    quote.fifty_two_week?.low || meta.fifty_two_week?.low
  );
  const fiftyTwoWeekHigh = formatNumber(
    quote.fifty_two_week?.high || meta.fifty_two_week?.high
  );
  const previousClose = formatNumber(quote.pc);
  const volume = quote.volume ? Number(quote.volume).toLocaleString() : "—";

  return (
    <div className="instrument-quote-data">
      <span className="home-v3-kicker">Price</span>
      <h1 style={{ margin: "10px 0 8px" }}>${price}</h1>
      <p className="meta-copy" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {isNegativeChange ? <BsFillCaretDownFill style={{ color: "#ff8e8e" }} /> : <BsFillCaretUpFill style={{ color: "#7ce3a1" }} />}
        {` ${isNegativeChange ? "" : "+"}${change} (${percentChange}%)`}
      </p>

      <div className="finance-detail-grid" style={{ marginTop: "18px" }}>
        <div className="finance-detail-row">
          <span className="finance-detail-label">Symbol</span>
          <span className="finance-detail-value">{quote.symbol || meta.symbol || "—"}</span>
        </div>
        <div className="finance-detail-row">
          <span className="finance-detail-label">Previous close</span>
          <span className="finance-detail-value">{previousClose}</span>
        </div>
        <div className="finance-detail-row">
          <span className="finance-detail-label">Day range</span>
          <span className="finance-detail-value">{dayLow} - {dayHigh}</span>
        </div>
        <div className="finance-detail-row">
          <span className="finance-detail-label">Volume</span>
          <span className="finance-detail-value">{volume}</span>
        </div>
        <div className="finance-detail-row">
          <span className="finance-detail-label">Exchange</span>
          <span className="finance-detail-value">{quote.exchange || meta.exchange || "—"}</span>
        </div>
        <div className="finance-detail-row">
          <span className="finance-detail-label">Name</span>
          <span className="finance-detail-value">{quote.name || meta.name || "—"}</span>
        </div>
      </div>

      <div className="finance-range-panel" style={{ marginTop: "18px" }}>
        <div className="finance-range-head">
          <span className="finance-detail-label">52-week range</span>
          <span className="finance-range-values">
            <span>{fiftyTwoWeekLow}</span>
            <span>{fiftyTwoWeekHigh}</span>
          </span>
        </div>
        <div className="finance-range-track" aria-hidden="true">
          <span className="finance-range-fill" style={{ width: "100%" }} />
        </div>
      </div>
    </div>
  );
}
